export enum MilestoneAssignedStatus {
    ToMe = "to Me",
    ByMe = "by Me",
    ToMyTeam = "to My Teams",
    ToNoOne = "to No One",
    ToAnyone = "to Anyone",
    ImTheApprover = "I'm the Approver",
    ImTheObserver = "I'm the Observer",
    FavoriteTasks = "Favorite Tasks",
}